import React from 'react'
import { Router, Route, IndexRoute, browserHistory } from 'react-router'

import Container from './containers/Container';

import Splash from './components/Splash';
import Account from './components/Account';
import Unsubscribe from './components/Unsubscribe';
import GeoList from './components/GeoList';
import Track from './components/Track';
import Vote from './components/Vote';
import Escape from './components/Escape';
import AboutUs from './components/AboutUs';
import TrackLocation from './components/TrackLocation';
import Claim from './components/Claim';
import Spreadsheet from './components/Spreadsheet';
import Top from './components/Top';
import PlayAtHome from './components/PlayAtHome';
import GiftCards from './components/GiftCards';
import Map from './components/Map';
import Main from './components/Main';
import MyProfile from './components/MyProfile';
import Profile from './components/Profile';
import ProfileMap from './components/ProfileMap';
import LeaderboardEmbed from './components/LeaderboardEmbed';
import Team from './components/Team';
import City from './components/City';
import Region from './components/Region';
import Company from './components/Company';
import Manage from './components/Manage';
import ManageCompany from './components/ManageCompany';
import ManageRoom from './components/ManageRoom';
import AddRoom from './components/AddRoom';
import Room from './components/Room';
import Leaderboard from './components/Leaderboard';
import ProSplash from './components/ProSplash';
import ProOnboard from './components/ProOnboard';
import ProOnboardChoose from './components/ProOnboardChoose';
import ProDashboard from './components/ProDashboard';
import ProManage from './components/ProManage';
import ProManageRoom from './components/ProManageRoom';
import ProAddRoom from './components/ProAddRoom';
import ProBookings from './components/ProBookings';
import ProBooking from './components/ProBooking';
import ProSettings from './components/ProSettings';
import ProWidget from './components/ProWidget';
import ProIntegrations from './components/ProIntegrations';
import ProLeaderboards from './components/ProLeaderboards';
import ProGiftCards from './components/ProGiftCards';
import Magic from './components/Magic.js';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import OauthGoogle from './components/OauthGoogle';
import RemountHack from './components/RemountHack';
import Admin from './components/admin/Admin';
import NoMatch from './components/NoMatch';


const Routes = props => {
  return (
    <Router history={browserHistory}>
      <Route path="/" component={Container}>
        <IndexRoute component={Splash} />
        <Route path="/s" component={Main} />
        <Route path="/account" component={Account} />
        <Route path="/unsubscribe/:key" component={Unsubscribe} />
        <Route path="/t/:id" component={TrackLocation} />
        <Route path="/track" component={Track} />
        <Route path="/tc" component={Track} />
        <Route path="/vote" component={Vote} />
        <Route path="/play-at-home" component={PlayAtHome} />
        <Route path="/gift-cards" component={GiftCards} />
        <Route path="/about" component={AboutUs} />
        <Route path="/manage" component={Manage} />
        <Route path="/manage/:id" component={ManageCompany} />
        <Route path="/claim/:id" component={Claim} />
        <Route path="/sh" component={Spreadsheet} />
        <Route path="/geo" component={GeoList} />
        <Route path="/cities" component={GeoList} />
        <Route path="/top" component={Top} />
        <Route path="/map" component={Map} />
        <Route path="/me" component={MyProfile} />
        <Route path="/ld" component={Leaderboard} />
        <Route path="/cl" component={RemountHack} />
        <Route path="/leaderboard" component={Leaderboard} />
        <Route path="/leaderboard/:id" component={LeaderboardEmbed} />
        <Route path="/p/:username" component={Profile} />
        <Route path="/map/:username" component={ProfileMap} />
        <Route path="/team/:id" component={Team} />
        <Route path="/c/:slug" component={City} />
        <Route path="/co/:slug/:id" component={Company} />
        <Route path="/r/add" component={AddRoom} />
        <Route path="/r/:slug/:id/manage" component={ManageRoom} />
        <Route path="/r/:slug/:id" component={Room} />
        <Route path="/e/:slug/:id" component={Escape} />
        <Route path="/region/:slug" component={Region} />
        <Route path="/m/:token" component={Magic} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/tos" component={Terms} />
        <Route path="/oauth/google" component={OauthGoogle} />
        <Route path="/admin" component={Admin} />
        <Route path="/pro" component={ProSplash} />
        <Route path="/pro/onboard" component={ProOnboard} />
        <Route path="/pro/onboard/choose" component={ProOnboardChoose} />
        {/*<Route path="/pro/manage" component={ProDashboard} />*/}

        <Route path="/pro/rooms" component={ProManage} />
        <Route path="/pro/rooms/add" component={ProAddRoom} />
        <Route path="/pro/rooms/:id" component={ProManageRoom} />
        <Route path="/pro/bookings" component={ProBookings} />
        <Route path="/pro/bookings/:id" component={ProBooking} />
        <Route path="/pro/settings" component={ProSettings} />
        <Route path="/pro/widget" component={ProWidget} />
        <Route path="/pro/integrations" component={ProIntegrations} />
        <Route path="/pro/leaderboards" component={ProLeaderboards} />
        <Route path="/pro/gift-cards" component={ProGiftCards} />

        <Route path="*" component={NoMatch} />
      </Route>
    </Router>
  )
}

export default Routes;



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/